import React, { FC } from "react";
import { GuardianProvider } from "./context/GuardianContext";
import { GuardianContainer } from "./components/Guardian/container";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './styles/components/Guardian.css'

export const GuardianApp: FC = () => {
    return (
        <GuardianProvider>
            <GuardianContainer />
            <ToastContainer autoClose={false} />
        </GuardianProvider>
    );
}